import { useTheme, useMediaQuery } from '../styles/index';

export function useDevice() {
  const theme = useTheme();
  const desktop = useMediaQuery(theme.breakpoints.up('md'));
  return {
    mobile: !desktop,
    desktop
  };
}
